import { useTranslation } from 'react-i18next'
import { ArrowTriangleIcon } from '@honestica/curecall-ui'
import {
  TPatientMedEventsByRangeOfDays,
  TPlanningFilters,
  TPlanningTab,
  TSearchPlanningTab,
} from '../planning.type'
import { twMerge } from 'src/utils/tw-merge.util'

interface PlanningRangeOfDaysProps {
  planningTab: TPlanningTab | TSearchPlanningTab
  currentFilters: TPlanningFilters
  updatePlanningFilters: (filters: Partial<TPlanningFilters>) => void
  patientMedEventsByRangeOfDays?: TPatientMedEventsByRangeOfDays
}
export default function PlanningRangeOfDays({
  planningTab,
  currentFilters,
  updatePlanningFilters,
  patientMedEventsByRangeOfDays,
}: Readonly<PlanningRangeOfDaysProps>) {
  const { t } = useTranslation()
  const [startOfRangeOfDay, endOfRangeOfDay] = planningTab.relativeRangeOfDays
  const daysArray = Array.from(
    { length: endOfRangeOfDay - startOfRangeOfDay + 1 },
    (_, i) => startOfRangeOfDay + i,
  )

  const handleChangeRelativeDay = (relativeDay: number) => {
    updatePlanningFilters({ relativeDaysFromToday: Number(relativeDay) })
  }

  return (
    <div className="c-flex c-gap-2" data-planning-tour="days">
      <button
        type="button"
        className="c-text-primary hover:c-text-primary-500 c-group"
        aria-label={t('pages.planning.previous-day-button')}
        onClick={() => handleChangeRelativeDay(currentFilters.relativeDaysFromToday - 1)}
      >
        <ArrowTriangleIcon
          position="LEFT"
          className="c-w-4 c-text-primary c-inline-block group-hover:c-text-primary-500"
        />
      </button>
      {daysArray.map((relativeDay) => {
        const isAnEmptyDay = patientMedEventsByRangeOfDays?.some(
          (item) => item.relativeDay === relativeDay && !item.hasPatientMedEvent,
        )
        return (
          <button
            key={`${planningTab.id}-${relativeDay}`}
            onClick={() => handleChangeRelativeDay(relativeDay)}
            className={twMerge(
              'c-p-1.5 c-border c-border-solid c-border-grey-500 c-rounded hover:c-bg-primary-200 c-h-min',
              currentFilters.relativeDaysFromToday === relativeDay &&
                'c-bg-primary-600 c-text-white hover:c-text-primary-900 c-border-primary-600',
              isAnEmptyDay && 'c-bg-grey-200 hover:c-bg-grey-100',
              isAnEmptyDay &&
                currentFilters.relativeDaysFromToday === relativeDay &&
                'c-text-primary-600 c-border-2',
            )}
          >
            {t('pages.planning.range-of-days.relative-day', {
              isPreviousDay: relativeDay === 0 ? null : relativeDay < 0,
              relativeDay: Math.abs(relativeDay),
            })}
          </button>
        )
      })}
      <button
        type="button"
        className="c-text-primary hover:c-text-primary-500 c-group"
        aria-label={t('pages.planning.next-day-button')}
        onClick={() => handleChangeRelativeDay(currentFilters.relativeDaysFromToday + 1)}
      >
        <ArrowTriangleIcon
          position="RIGHT"
          className="c-w-4 c-text-primary c-inline-block group-hover:c-text-primary-500"
        />
      </button>
    </div>
  )
}
